module.exports = __webpack_public_path__ + "static/media/WhiteBackgroundMobile.a8e8d71f.jpg";